import { ExtensionBoilerplate } from '@adornis/buildify/client/extensions/ContentExtensionBoilerplate.js';
import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/digitale-helden-shared/client/theme/d-card.js';
import '@adornis/digitale-helden-shared/client/theme/d-checkbox';
import '@adornis/digitale-helden-shared/client/theme/d-icon';
import '@adornis/digitale-helden-shared/client/theme/d-input.js';
import { consentCookieValueSubject } from '@adornis/digitale-helden-shared/tracking/client/consent-tool.js';
import { CookieFactory } from '@adornis/digitale-helden-shared/tracking/client/types/CookieFactory.js';
import '@adornis/file-utils/client/x-image';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../client/theme/d-text.js';
import { BaseBookingFrame } from '../db/BaseBookingFrame.js';

export const MarketingBookingFrame: BuildifyExtension<BaseBookingFrame> = {
  class: BaseBookingFrame,
  toolbar: {
    icon: 'calendar-check',
    text: {
      default: 'Booking-Frame',
    },
  },
  group: 'Marketing',
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <marketing-booking-frame
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></marketing-booking-frame>
    `;
  },
  editor: ({ content, contentController, host, controllerBaseKeyPath }) => html`
    <d-flex space="md">
      <d-grid columns="50% 50%" space="sm">
        <d-text ${css({ alignSelf: 'end' })}>https://digitale&shy;helden.zoho&shy;bookings.eu/portal-embed#/</d-text>
        <d-input
          ${css({ alignSelf: 'end' })}
          placeholder="Bookings URL Slug"
          ${contentController.field(...controllerBaseKeyPath, 'urlSlug')}
        ></d-input>
      </d-grid>
      <d-input placeholder="Höhe des IFrames" ${contentController.field(...controllerBaseKeyPath, 'height')}></d-input>
    </d-flex>
  `,
};

@customElement('marketing-booking-frame')
export class MBookingFrame extends ExtensionBoilerplate<BaseBookingFrame> {
  override connectedCallback(): void {
    super.connectedCallback();

    consentCookieValueSubject.subscribe(value => {
      this.requestUpdate();
    });
  }

  override _content(content: BaseBookingFrame) {
    if (!CookieFactory.consentCookie.getValue('allowZohoBookings', 'boolean'))
      return html`
        <d-flex
          ${css({ width: '100%', aspectRatio: '16 / 4', color: '#fff', background: '#333' })}
          center
          crossaxis-center
          space="md"
        >
          <d-text> Bitte aktiviere ZohoBooking-Cookies, um einen Termin auszumachen. </d-text>
          <d-button
            @click=${() => {
              CookieFactory.consentCookie.setValue('allowZohoBookings', 'true');
              this.requestUpdate();
            }}
          >
            Cookies erlauben
          </d-button>
        </d-flex>
      `;

    return html`
      <iframe
        width="100%"
        height=${content.height ? content.height : '540px'}
        frameborder="0"
        allowfullscreen=""
        src=${`https://digitalehelden.zohobookings.eu/portal-embed#/${content.urlSlug}`}
      ></iframe>
    `;
  }
}
